"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timedCounterWidget = void 0;
var widgets_main_1 = require("../widgets-main");
var timedCounterWidget = function (currentValue, maxValue, step, updateDelay) { return (0, widgets_main_1.onlyIf)(currentValue < maxValue, (0, widgets_main_1.wait)(updateDelay || 5, { key: "timed counter updater" })(function () { return function (x) { return x + (step || 5); }; })); };
exports.timedCounterWidget = timedCounterWidget;
